import script from "./projectInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./projectInfo.vue?vue&type=script&lang=ts&setup=true"

import "./projectInfo.vue?vue&type=style&index=0&id=adf3a1f6&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adf3a1f6"]])

export default __exports__